// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MPdr","toggle":"styles_toggle__15D4d","preview":"styles_preview__zg1dB"};